import service from './network';

export function getUserVerificationPicture(data){
    return service.request({
        url: '/user/verification/picture',
        method: 'get',
        params: data
    })
}